import { useEffect } from 'react';

/**
 * Forces a full page reload when the browser restores the page from bfcache
 * (back-forward cache). Without this, pressing "Back" from an external OAuth
 * page (e.g. Keycloak) restores stale React state — including
 * `loginInProgress: true` — causing the app to stay stuck on the loading
 * skeleton indefinitely because no lifecycle hooks re-run.
 */
export function useBfcacheGuard(): void {
  useEffect(() => {
    const handler = (event: PageTransitionEvent) => {
      if (event.persisted) {
        window.location.reload();
      }
    };
    window.addEventListener('pageshow', handler);
    return () => window.removeEventListener('pageshow', handler);
  }, []);
}
